import React from 'react'; // Ya no necesitamos useState
import ValidatedInput from './ValidatedInput';
// Mantenemos tu ruta de importación exacta
import { validateCurpResponse, validateRfcResponse, validateEmailResponse, validatePhoneResponse, validateIneResponse, validateDomainResponse } from '../../utils/validators'; 
import "./ValidationForm.css";
import ValidatedOcrInput from './ValidatedOcrInput';
import ValidatedAddressInput from './ValidatedAddressInput';


function OnboardingBoard() {
    // Eliminamos el estado 'currentStep' y las funciones 'setCurrentStep'
    // para que no exista dependencia entre un paso y el otro.

    return (
        <div className="dashboard_content form_layout">
            <div className="dashboard_content_header">
                <h1>Verificación de Cliente (Onboarding)</h1>
            </div>
            <div className="dashboard_main_scroll">
                <div className="dashboard_main_wrapper form_wrapper_center">
                    <p className="endpoint_description">
                        Valide la información del cliente. Los servicios están disponibles de forma independiente.
                    </p>

                    <div className="validation_steps_container">
                        
                        {/* PASO 1: CURP */}
                        <ValidatedInput 
                            label="1. Validación de CURP"
                            placeholder="Ingrese CURP..."
                            endpointId="48662deb-c14d-453e-9784-70832a7605e0"
                            paramName="curp"
                            validatorFunction={validateCurpResponse}
                            isDisabled={false} // Siempre activo
                            // Eliminamos onSuccess
                        />

                        {/* PASO 2: RFC */}
                        <ValidatedInput 
                            label="2. Validación de RFC"
                            placeholder="Ingrese RFC..."
                            endpointId="95af0681-1f7f-4165-b756-597e9de74557"
                            paramName="rfc"
                            validatorFunction={validateRfcResponse}
                            isDisabled={false} // Siempre activo
                            // Eliminamos onSuccess
                        />

                        {/* PASO 3: EMAIL CHECK */}
                        <ValidatedInput 
                            label="3. Validación de Correo Electrónico"
                            placeholder="cliente@ejemplo.com"
                            endpointId="a6cc88ec-6a7a-4b98-9274-f9645a50d062"
                            paramName="email"
                            validatorFunction={validateEmailResponse}
                            isDisabled={false} // Siempre activo
                            // Eliminamos onSuccess
                        />

                        {/* PASO 4. TELÉFONO (NUEVO) */}
                        <ValidatedInput 
                            label="4. Validación de Teléfono"
                            placeholder="Ej: 525512345678"
                            endpointId="1f581de8-53db-4f27-80ed-3a3afd327f9c"
                            paramName="phone"
                            validatorFunction={validatePhoneResponse}
                            isDisabled={false} 
                        />

                      {/* 5. INE / OCR (NUEVO) */}
                        <ValidatedOcrInput 
                            label="5. Validación Documento (INE/IFE)"
                            endpointId="48e6f480-8c1c-448d-af57-373457fd716e"
                            validatorFunction={validateIneResponse}
                        />

                       {/* 6. DOMINIO WEB (NUEVO - Antes del Email) */}
                        <ValidatedInput 
                            label="3. Validación de Dominio Web"
                            placeholder="Ej: empresa.com"
                            endpointId="a6cc88ec-6a7a-4b98-9274-f9645a50d062" // Usamos el de Email
                            paramName="email" // La API espera "email"
                            validatorFunction={validateDomainResponse} // Usamos lógica de dominio
                            // TRUCO: Le agregamos 'info@' para engañar a la API y que busque el dominio
                            transformValue={(val) => {
                                // Si el usuario puso 'http', lo limpiamos
                                let domain = val.replace(/^https?:\/\//, '').replace(/\/$/, '');
                                return `info@${domain}`;
                            }}
                        />

                        {/* 7. DIRECCIÓN (NUEVO) */}
                        <ValidatedAddressInput 
                            label="6. Validación de Domicilio"
                            googleApiKey="AIzaSyDHxnzcMy12egJyYEQsNMbpH9T6BHuMr_c" 
                        />

                    </div>
                </div>
            </div>
        </div>
    );
}

export default OnboardingBoard;